// extracted by mini-css-extract-plugin
export default {"icon":"qruCvh","left":"Qz71kc"};